import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import ButtonBox from './ButtonBox.js';
import { BUTTON_BOX_SIZE } from '../../constants/button.js';
import styles from './ButtonBoxDouble.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 *
 * 가능한 variant 조합
 *  1. `max`
 *    - leftButton: `priamry` | `secondary`
 *    - rightButton: `priamry` | `secondary`
 *  2. `large`
 *    - leftButton + rightButton: `secondary`+`primary`
 *    - leftButton + rightButton: `tertiary`+`primary`
 *    - leftButton + rightButton: `basic`+`primary`
 *    - leftButton + rightButton: `tertiary`+`tertiary`
 *  3. `medium`
 *    - leftButton + rightButton: `tertiary`+`primary`
 *    - leftButton + rightButton: `secondary`+`tertiary`
 *    - leftButton + rightButton: `tertiary`+`tertiary`
 *    - leftButton + rightButton: `basic`+`basic`
 *
 */
function ButtonBoxDouble(_ref) {
  var size = _ref.size,
    ratio = _ref.ratio,
    leftButton = _ref.leftButton,
    rightButton = _ref.rightButton;
  var innerButtonWideProps = size === BUTTON_BOX_SIZE.MAX ? {} : {
    isWide: true
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', "size-".concat(size), "type-".concat(ratio))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('cell')
  }, /*#__PURE__*/React.createElement(ButtonBox, _objectSpread({}, _objectSpread(_objectSpread({}, leftButton), {}, {
    size: size
  }, innerButtonWideProps)))), /*#__PURE__*/React.createElement("div", {
    className: cx('cell')
  }, /*#__PURE__*/React.createElement(ButtonBox, _objectSpread({}, _objectSpread(_objectSpread({}, rightButton), {}, {
    size: size
  }, innerButtonWideProps)))));
}

export { ButtonBoxDouble as default };
